import { render, staticRenderFns } from "./export-pricehubble.vue?vue&type=template&id=cef54c90&"
import script from "./export-pricehubble.vue?vue&type=script&lang=js&"
export * from "./export-pricehubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports